import Axios from "axios";
// const https = require("https");
// const url = require("url");
export const tryAgl = () => {
  window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
};

// export const tryAglAPI = async () => {
//   await Axios.get("/api/baidu-statistics");
//   const result = await Axios.get("/api/baidu-statistics");
//   console.log(result);
// };
export const tryAglAPI = async () => {
  const result = await Axios.get("/api/baidu-statistics");
  console.log(result);
  // const endpoint = "https://ocpc.baidu.com/ocpcapi/api/uploadConvertData";
  // const parsedEndpoint = url.parse(endpoint);
  // const postData = JSON.stringify({
  //   token: "Z6gh4Q8uBdGfNOFhimYELQEYsSYvxfXz@mIdUe0E9no7e6CXqMTAQNTXqdMH0308Q",
  //   conversionTypes: [
  //     {
  //       logidUrl:
  //         "https://open.feishu.cn/open-apis/bot/hook/c57eb4a2bcfe428d9bc31bf8d3264578?bd_vid=uANBIyIxuANvg1nsnW03nH0dg1PxnHmzP1c3rj01nHRsr0",
  //       newType: 3,
  //       convertType: 3,
  //     },
  //     {
  //       logidUrl:
  //         "https://console.authing.cn/login?app_id=5f6265c67ff6fdae64ec516e&uuid=u92q8qeHtmbu3DwULUo09&client_id=5f6265c67ff6fdae64ec516e&from_origin=authing.cn&nonce=6PdG6yw-Xz&redirect_uri=https%3A%2F%2Fconsole.authing.cn%2Fconsole%2Fuserpool%2Fcallback&response_type=code&scope=openid+profile+email+phone+offline_access&state=R991_kf36&bd_vid=uANBIyIxuANvg1nsnW03nH0dg1f4g1DvnWTsn1bdrHTkn1n",
  //       newType: 49,
  //       convertType: 49,
  //     },
  //   ],
  // });
  // const options = {
  //   hostname: parsedEndpoint.hostname,
  //   port: parsedEndpoint.port,
  //   path: parsedEndpoint.path,
  //   method: "POST",
  //   headers: {
  //     "Content-Type": "application/json",
  //     "Content-Length": postData.length,
  //   },
  // };
  // const req = https.request(options, (res) => {
  //   //检验状态码，如果成功接收数据
  //   if (res.statusCode === 200) {
  //     res.setEncoding("utf8");
  //     res.on("data", (chunk) => {
  //       console.log(`"res data: ${chunk}`);
  //     });
  //   }
  // });
  // req.on("error", (e) => {
  //   console.error(`problem with request: ${e.message}`);
  // });
  // req.write(postData);
  // req.end();
};
